<template>
    <div class="border border-secondary rounded p-4"
         @drop.prevent="processDroppedFile"
         @dragenter.prevent
         @dragover.prevent
    >
        <div v-if="files.length === 0"
             class="text-center py-5 cursor-pointer"
             @click="$refs.fileInput.click()"
        >
            <i class="fas fa-upload"/>
            Select or drop file for upload
        </div>
        <div v-else>
            <div v-for="(file, i) in files"
                 :key="i"
                 :class="{'border-bottom border-bottom-dotted': i < files.length - 1}"
            >
                <div class="d-flex flex-row align-items-center gap-3 my-2 py-1 px-3 bg-hover-light-light rounded-sm">
                    <div>
                        <i v-if="['xls','xlsx'].includes(mapMimeType(file.type))"
                           class="fas fa-file-excel font-size-h1"/>
                        <i v-else-if="mapMimeType(file.type) === 'csv'" class="fas fa-file-csv font-size-h1"/>
                        <i v-else class="fas fa-file font-size-h1"/>
                    </div>
                    <div class="flex-grow-1">
                        <div class="font-weight-bold">
                            {{ file.name }}
                        </div>
                        <div class="font-size-sm text-muted mt-n1">
                            {{ formatBytes(file.size) }}
                        </div>
                    </div>
                    <div>
                        <Badge v-if="isNotCompatible(file.type)"
                               type="text-warning"
                               icon="fas fa-exclamation-triangle"
                        >
                            Invalid file type
                        </Badge>
                        <Badge v-if="i >= maxFiles"
                               type="text-danger"
                               icon="fas fa-exclamation-triangle"
                        >
                            File limit reached
                        </Badge>
                    </div>
                    <div>
                        <button class="btn btn-sm btn-outline-secondary border-0 btn-hover-danger"
                                @click="removeFile(i)">
                            <i class="fas fa-times ml-1"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <input ref="fileInput"
               type="file"
               class="d-none"
               :multiple="maxFiles !== 1"
               :accept="acceptedMimeTypes"
               @input="files = Array.from($event.target.files)"
        >
    </div>
</template>

<script>
import Badge from "../Badge.vue";
import Alert from "../Alert.vue";

export default {
    components: {Alert, Badge},

    props: {
        value: Array,
        fileTypes: Array,
        maxFiles: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            files: []
        }
    },

    methods: {
        processDroppedFile(e) {
            this.files = Array.from(e.dataTransfer.files);
            this.$emit('input', this.files);
        },

        formatBytes(bytes, decimals) {
            if (bytes === 0) return '0 Bytes';
            let k = 1024,
                dm = decimals || 2,
                sizes = ['Bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },

        removeFile(index) {
            this.files.splice(index, 1);
            this.$emit('input', this.files);
        },

        isNotCompatible(mimeType) {
            let extension = this.mapMimeType(mimeType);
            return !this.fileTypes.includes(extension)
        },

        mapMimeType(mimeType) {
            return Mime.extension(mimeType);
        }
    },

    computed: {
        acceptedMimeTypes() {
            let mimeTypes = [];
            for (let fileExtension of this.fileTypes) {
                mimeTypes.push(Mime.lookup(fileExtension));
            }
            return mimeTypes;
        }
    }
}
</script>
